module.exports = __webpack_public_path__ + "files/0090793025467d22ab41916ec885da18.png";